import { InputClearButton, TextInput, type TextInputProps, rem } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import cls from './styles.module.css';

interface SearchInputProps extends Omit<TextInputProps, 'onChange'> {
  onChange: (value: string) => void;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  ...props
}: SearchInputProps) {
  const t = useTranslations();

  return (
    <TextInput
      value={value}
      className={cls.root}
      rightSectionWidth={rem(40)}
      leftSection={<IconSearch size={20} />}
      placeholder={placeholder || t('search')}
      rightSection={value && <InputClearButton onClick={() => onChange('')} />}
      onChange={(event) => onChange(event.target.value)}
      {...props}
    />
  );
}
